import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "AggregateSales";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row m-0">
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 m-0">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label}
                    hintText={LOOKUP.report.common.beginDate.label}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label}
                    hintText={LOOKUP.report.common.endDate.label}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <SelectInput
                    defaultValue="2"
                    name={componentName + "Group"}
                    fullWidth={true}
                    label={"Aggregate By"}
                    floatingLabelText={"Aggregate By"}
                    hintText={"Aggregate By"}
                    options={props.groupOptions && props.groupOptions.length > 0 ? props.groupOptions : []}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 mt-1 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>Only completed & partially refunded orders during the selected period will be counted in this report, the Net Sales value is used.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;